export const ReferXIcon: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (
  props,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="37"
      height="36"
      viewBox="0 0 37 36"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.0755 0.000976562C33.27 0.000976562 36.6394 3.37593 36.6394 8.57901V27.4225C36.6394 32.6256 33.27 36.0005 28.0755 36.0005H9.2631C4.06861 36.0005 0.699219 32.6256 0.699219 27.4225V8.57901C0.699219 3.37593 4.06861 0.000976562 9.2631 0.000976562H28.0755Z"
        fill="#8065C9"
      />
      <path
        d="M21.2034 16.4753L29.3439 7.20117H27.4156L20.3442 15.2521L14.7004 7.20117H8.18945L16.7257 19.3768L8.18945 29.1009H10.1178L17.5806 20.597L23.5421 29.1009H30.053M10.8138 8.62639H13.7763L27.4141 27.7457H24.4509"
        fill="white"
      />
    </svg>
  );
};

export default ReferXIcon;
